import SamplesEdit from "./SamplesEdit";
import { SamplesList } from "./SamplesList";
import SamplesShow from "./SamplesShow";
import SamplesCreate from "./SamplesCreate";

export const samples = {
  list: SamplesList,
  edit: SamplesEdit,
  show: SamplesShow,
  create: SamplesCreate,
};
